import { css } from '@emotion/react';

/** TODO: 디자인시스템 버그 수정 시, 해당 기능 제거 후 대체 */
function HOVER(template) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return (
    /*#__PURE__*/
    /*#__PURE__*/
    css("&.focus-visible:focus{",
    /*#__PURE__*/
    /*#__PURE__*/
    css.apply(void 0, [template].concat(args)), ";}@media(hover: hover) and (pointer: fine){&:hover,&:active{",
    /*#__PURE__*/
    /*#__PURE__*/
    css.apply(void 0, [template].concat(args)), ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:HOVER;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImhvdmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU9ZIiwiZmlsZSI6ImhvdmVyLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzLCBTZXJpYWxpemVkU3R5bGVzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG4vKiogVE9ETzog65SU7J6Q7J247Iuc7Iqk7YWcIOuyhOq3uCDsiJjsoJUg7IucLCDtlbTri7kg6riw64qlIOygnOqxsCDtm4Qg64yA7LK0ICovXG5leHBvcnQgZnVuY3Rpb24gSE9WRVIoXG4gIHRlbXBsYXRlOiBUZW1wbGF0ZVN0cmluZ3NBcnJheSxcbiAgLi4uYXJnczogUGFyYW1ldGVyczx0eXBlb2YgY3NzPltudW1iZXJdW11cbik6IFNlcmlhbGl6ZWRTdHlsZXMge1xuICByZXR1cm4gY3NzYFxuICAgICYuZm9jdXMtdmlzaWJsZTpmb2N1cyB7XG4gICAgICAke2Nzcyh0ZW1wbGF0ZSwgLi4uYXJncyl9XG4gICAgfVxuICAgIEBtZWRpYShob3ZlcjogaG92ZXIpIGFuZCAocG9pbnRlcjogZmluZSkge1xuICAgICAgJjpob3ZlciwgJjphY3RpdmUge1xuICAgICAgICAke2Nzcyh0ZW1wbGF0ZSwgLi4uYXJncyl9XG4gICAgICB9XG4gICAgfVxuICBgO1xufVxuIl19 */", process.env.NODE_ENV === "production" ? "" : ";label:HOVER;")
  );
}

export { HOVER };
//# sourceMappingURL=hover.js.map
